import type { MessageDescriptor } from "@lingui/core";

import { msg } from "@lingui/core/macro";

export const diagConfidence: number[] = [0, 25, 50, 75, 100];

export const tokenExpiries: Record<string, MessageDescriptor> = {
  P1D: msg`1 day`,
  P2D: msg`2 days`,
  P1W: msg`1 week`,
  P2W: msg`2 weeks`,
};

export const connectedRoles = ["patient-ppg-app", "patient"];

export const managingRoles = [
  "physician-ppg-app",
  "physician",
  "study-physician",
];

export const deviceHandovers: Record<string, MessageDescriptor> = {
  patient_in_person: msg`in-person`,
  patient_remote_send: msg`sending by post`,
};

export const routePatients = "/";
export const routePatient = "/patient/:id";
export const routePatientTab = "/patient/:id/:tab";
export const routeAddPatient = "/add-patient";
export const routeMedWaitingRoom = "/med-waiting-room";
export const routeTechWaitingRoom = "/tech-waiting-room";
export const routeAdmin = "/admin";
export const routeAdminTab = "/admin/:adtab";

export enum SearchParam {
  redirect = "redirect",
}
